import { api } from "../../../utils/api";
import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import $ from "jquery";
import "daterangepicker";
import "daterangepicker/daterangepicker.css";
import MobileLayout from "../../../layouts/MobileLayout";
import { alignPickerToFilter } from "../../../utils/mobileDatePicker";
import { AttendanceLogView } from "../../../components/mobile/AttendanceRecords";
import { useAuthStore } from "../../../store/authStore";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";


const AttendanceLog = () => {
  const navigate = useNavigate();

  const pickerRef = useRef(null);

  const { user, isAuthenticated } = useAuthStore();

  const companyId = user?.company_id;
  const userId = user?.user_id;

  const [startDate, setStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD"),
  );

  const [endDate, setEndDate] = useState(
    moment().endOf("month").format("YYYY-MM-DD"),
  );

  useEffect(() => {
    const $picker = $(pickerRef.current);

    if ($picker.data("daterangepicker")) {
      $picker.data("daterangepicker").remove();
    }

    $picker.daterangepicker({
      startDate: moment(startDate),
      endDate: moment(endDate),

      autoUpdateInput: false,

      showDropdowns: true,
      linkedCalendars: false,
      alwaysShowCalendars: true,

      opens: "left",

      ranges: {
        Today: [moment(), moment()],
        Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
        "Last 7 Days": [moment().subtract(6, "days"), moment()],
        "Last 30 Days": [moment().subtract(29, "days"), moment()],
        "This Month": [moment().startOf("month"), moment().endOf("month")],
        "Last Month": [
          moment().subtract(1, "month").startOf("month"),
          moment().subtract(1, "month").endOf("month"),
        ],
      },
    });

    const picker = $picker.data("daterangepicker");

    picker.container.addClass("mobile-daterangepicker");

    // popup sits right under the filter card, at the card's width
    const unalign = alignPickerToFilter(picker, pickerRef.current);

    $picker
      .off("apply.daterangepicker")
      .on("apply.daterangepicker", function (ev, picker) {
        const from = picker.startDate.format("YYYY-MM-DD");
        const to = picker.endDate.format("YYYY-MM-DD");

        setStartDate(from);
        setEndDate(to);
      });

    return () => {
      unalign();

      if ($picker.data("daterangepicker")) {
        $picker.data("daterangepicker").remove();
      }
    };
  }, []);

  useEffect(() => {
    if (companyId && userId && isAuthenticated) {
      fetchAttendanceLogs(startDate, endDate);
    }
  }, [companyId, userId, isAuthenticated, startDate, endDate]);

  const [attendanceLogs, setAttendanceLogs] = useState([]);

  const fetchAttendanceLogs = async (from = startDate, to = endDate) => {
    try {
      const response = await api.get(
        `/attendance/attendance-log?company_id=${companyId}&user_id=${userId}&from_date=${from}&to_date=${to}`,
      );

      const result = await response.json();

      console.log(result);

      if (!response.ok || !result.status) {
        throw new Error(result.message || "Failed to load attendance log");
      }

      setAttendanceLogs(result.data || []);
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  };

  const fetchShiftForDate = async (date) => {
    try {
      const response = await api.get(
        `/attendance/shift-for-date?company_id=${companyId}&user_id=${userId}&target_date=${date}`,
      );

      const result = await response.json();

      if (!response.ok || !result.status) {
        throw new Error(result.message || "Failed to load shift details");
      }

      return result;
    } catch (err) {
      console.error("Shift API error:", err);
      throw err;
    }
  };

  const handleRegularize = async (item) => {
    try {
      const selectedDate = moment(item.date).format("YYYY-MM-DD");

      // ==========================================
      // FUTURE DATE CHECK
      // ==========================================
      if (moment(selectedDate).isAfter(moment(), "day")) {
        toast.warning("You cannot regularize attendance for a future date.");
        return;
      }

      // ==========================================
      // GET SHIFT DETAILS FOR THIS DATE
      // ==========================================
      const shiftResult = await fetchShiftForDate(selectedDate);

      console.log("Shift API result:", shiftResult);

      // ==========================================
      // WEEK OFF CHECK
      // ==========================================
      if (shiftResult.type === "Weekoff") {
        toast.info(
          shiftResult.message || "Regularization is not allowed on a Week Off.",
        );
        return;
      }

      // ==========================================
      // HOLIDAY CHECK
      // ==========================================
      if (shiftResult.type === "Holiday") {
        toast.info(
          shiftResult.message || "Regularization is not allowed on a Holiday.",
        );
        return;
      }

      // ==========================================
      // NORMAL DATE → OPEN REGULARIZATION FORM
      // ==========================================
      navigate("/admin/mobile/attendanceform", {
        state: {
          // =========================
          // PUNCH DETAILS
          // =========================
          punchId: item.first_punch_id || 0,
          outId: item.last_punch_id || 0,

          // =========================
          // DATE
          // =========================
          date: moment(item.date).format("DD/MM/YYYY"),

          // =========================
          // PUNCH TIMES
          // =========================
          inTime: item.first_punch
            ? moment(item.first_punch).format("HH:mm")
            : shiftResult.shift_start_time || "-",

          outTime: item.last_punch
            ? moment(item.last_punch).format("HH:mm")
            : shiftResult.shift_end_time || "-",

          // =========================
          // SHIFT DETAILS
          // =========================
          shiftName: shiftResult.shift_name || "",
          shiftType: shiftResult.type || "",

          shiftStartTime: shiftResult.shift_start_time || "",
          shiftEndTime: shiftResult.shift_end_time || "",

          // =========================
          // HOLIDAY / WEEKOFF MESSAGE
          // =========================
          message: shiftResult.message || "",
        },
      });
    } catch (err) {
      console.error("Regularization error:", err);

      toast.error(err.message || "Unable to process regularization.");
    }
  };

  const isRegularizeDisabled = (item) =>
    moment(item.date).isAfter(moment(), "day") ||
    item.type === "Week Off" ||
    item.type === "Weekoff" ||
    item.type === "Holiday";

  return (
    <MobileLayout>
      <AttendanceLogView
        pickerRef={pickerRef}
        startDate={startDate}
        endDate={endDate}
        records={attendanceLogs}
        isRegularizeDisabled={isRegularizeDisabled}
        onRegularize={handleRegularize}
        onBack={() => navigate(-1)}
      />
    </MobileLayout>
  );
};

export default AttendanceLog;
